import { ApiExternalDtoMeasurementDeviceExternalDto } from '@redux/apiSlices/measurementDeviceApi';
import { ApiExternalDtoMeasurementPointExternalDto } from '@redux/apiSlices/measurementPointApi';

export const history: ApiExternalDtoMeasurementPointExternalDto[] = [
  {
    id: 0,
    tsoId: 0,
    name: 'string',
    substationId: 0,
    transducerModelVoltage1Id: 0,
    transducerModelVoltage2Id: 0,
    transducerModelVoltage3Id: 0,
    transducerModelCurrent1Id: 0,
    transducerModelCurrent2Id: 0,
    transducerModelCurrent3Id: 0,
    voltageLevelId: 0,
    connectionPoint: 0,
    activeFrom: '2025-03-24T15:16:34.575Z',
    activeTo: '2025-03-24T15:16:34.575Z',
    comment: 'string',
  },
  {
    id: 1,
    tsoId: 0,
    name: 'string',
    substationId: 0,
    transducerModelVoltage1Id: 0,
    transducerModelVoltage2Id: 0,
    transducerModelVoltage3Id: 0,
    transducerModelCurrent1Id: 0,
    transducerModelCurrent2Id: 0,
    transducerModelCurrent3Id: 0,
    voltageLevelId: 0,
    connectionPoint: 0,
    activeFrom: '2025-03-24T15:16:34.575Z',
    activeTo: '2025-03-24T15:16:34.575Z',
    comment: 'string',
  },
  {
    id: 2,
    tsoId: 0,
    name: 'string',
    substationId: 0,
    transducerModelVoltage1Id: 0,
    transducerModelVoltage2Id: 0,
    transducerModelVoltage3Id: 0,
    transducerModelCurrent1Id: 0,
    transducerModelCurrent2Id: 0,
    transducerModelCurrent3Id: 0,
    voltageLevelId: 0,
    connectionPoint: 0,
    activeFrom: '2025-03-24T15:16:34.575Z',
    activeTo: '2025-03-24T15:16:34.575Z',
    comment: 'string',
  },
];

export const deviceHistory: ApiExternalDtoMeasurementDeviceExternalDto[] = [
  {
    id: 0,
    tsoId: 0,
    name: 'string',
    technicalName: 'string',
    manufacturingYear: 2000,
    activeFrom: '2025-03-24T15:16:34.575Z',
    activeTo: '2025-03-24T15:16:34.575Z',
    comment: 'string',
    measurementDeviceModelId: 1,
    measurementPointId: 1,
  },
  {
    id: 1,
    tsoId: 1,
    name: 'string',
    technicalName: 'string',
    manufacturingYear: 2000,
    activeFrom: '2025-03-24T15:16:34.575Z',
    activeTo: '2025-03-24T15:16:34.575Z',
    comment: 'string',
    measurementDeviceModelId: 2,
    measurementPointId: 2,
  },
];
